"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = __importDefault(require("./styles"));
var Snackbar = function (_a) {
    var isHidden = _a.isHidden, style = _a.style, className = _a.className, type = _a.type, message = _a.message, children = _a.children;
    if (isHidden)
        return null;
    var iconName;
    switch (type) {
        case 'info':
            iconName = 'info';
            break;
        case 'success':
            iconName = 'ok';
            break;
        case 'warning':
            iconName = 'attention';
            break;
        case 'error':
            iconName = 'close';
            break;
        default:
            iconName = 'info';
    }
    return (react_1.default.createElement(styles_1.default, { style: style, className: className + " " + type },
        react_1.default.createElement(Icon_1.default, { icon: iconName, className: "icon" }),
        react_1.default.createElement("span", { className: "message" }, message), children !== null && children !== void 0 ? children : null));
};
exports.default = Snackbar;
//# sourceMappingURL=index.js.map